if (!customElements.get('np-limited-product')) {
  customElements.define('np-limited-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.start = Date.parse(this.dataset.start);
      this.end = this.start + 30 * 86400000;
      this.review = this.dataset.review === 'true';
      this.button = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.label = this.button?.textContent;
      this.tick();
      if (!this.review && Number.isFinite(this.start)) this.timer = setInterval(() => this.tick(), 1000);
      this.querySelector('form')?.addEventListener('submit', event => { event.preventDefault(); this.purchase(); });
    }
    disconnectedCallback() { clearInterval(this.timer); this.initialized = false; }
    tick() {
      const now = Date.now();
      this.active = !this.review && Number.isFinite(this.start) && now >= this.start && now < this.end;
      if (this.button) this.button.disabled = !this.active || this.busy;
      if (this.review) { if (this.status) this.status.textContent = this.dataset.reviewNotice; return; }
      const remaining = Math.max(0, Math.floor((this.end - now) / 1000));
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector('[data-unit="' + unit + '"]').textContent = Number.isFinite(value) ? String(value).padStart(2, '0') : '00';
      if (!this.active) this.querySelector('[data-clock-label]').textContent = now >= this.end ? this.dataset.expired : this.dataset.upcoming;
    }
    async purchase() {
      this.tick();
      if (!this.active || this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.status.textContent = '';
      const root = this.dataset.root, code = this.dataset.code, pump = Number(this.dataset.pump), robot = Number(this.dataset.robot);
      const request = async (path, body) => {
        const response = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', ...(body ? { body: JSON.stringify(body) } : {}) });
        const data = await response.json();
        if (!response.ok) throw new Error('cart');
        return data;
      };
      let before;
      try {
        if (!pump || !robot) throw new Error('variant');
        before = await request('cart.js');
        const existing = before.items.filter(item => item.properties?._np_offer === code);
        if (existing.length !== 2 || !existing.some(item => item.id === pump && item.quantity === 1) || !existing.some(item => item.id === robot && item.quantity === 1)) {
          if (existing.length) throw new Error('quantity');
          await request('cart/add.js', { items: [{ id: pump, quantity: 1, properties: { _np_offer: code } }, { id: robot, quantity: 1, properties: { _np_offer: code } }] });
        }
        const previousCodes = (before.discount_codes || []).map(discount => discount.code).filter(value => value.toUpperCase() !== code.toUpperCase());
        await request('cart/update.js', { discount: [...previousCodes, code].join(',') });
        const cart = await request('cart.js');
        const pumpLine = cart.items.find(item => item.id === pump && item.properties?._np_offer === code);
        const robotLine = cart.items.find(item => item.id === robot && item.properties?._np_offer === code);
        if (!pumpLine || !robotLine || pumpLine.quantity !== 1 || robotLine.quantity !== 1 || pumpLine.final_line_price !== Number(this.dataset.price) || robotLine.final_line_price !== 0) throw new Error('offer');
        window.location.assign(root + 'cart');
      } catch (error) {
        let restored = true;
        if (before) {
          try {
            const current = await request('cart.js'), updates = {};
            for (const item of current.items.filter(item => item.properties?._np_offer === code)) updates[item.key] = before.items.find(old => old.id === item.id && old.properties?._np_offer === code)?.quantity || 0;
            await request('cart/update.js', { updates, discount: (before.discount_codes || []).map(discount => discount.code).join(',') });
          } catch (restoreError) { restored = false; }
        }
        this.status.textContent = restored ? this.dataset.error : this.dataset.restore;
        this.busy = false;
        this.button.textContent = this.label;
        this.tick();
      }
    }
  });
}
